module.exports = __webpack_public_path__ + "img/iconPlace.2229571c.png";